import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { getOrders } from '../../../MyApi/orders'
import DataTable from '../../UI/table/DataTable'
import StatusBadge from "../../orders/show/statusbadge"
import TableActions from '../../UI/table/TableActions'
import LoadingSpinner from '../../UI/spinner'
import { formatPrice } from '../../../utils/formatPrice'

const OrdersInfo = ({id}) => {
  const [current_page,setCurrentPage]=useState(1)
    const {data ,isLoading}=useQuery(["getOrders", id, current_page],()=>getOrders(id ,"",current_page))  
    const orders =data?.data?.orders ||{}
      const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;
    const ordersColumns = [
    { label: "معرف الطلب", accessor: "id" },
    { label: "المتجر", accessor: "store.name" }, 
    { label: "العميل", accessor: "user.name" },
    { label: "المبلغ المستحق", render: (row) => <div> {formatPrice(row?.pricing?.currency_factor ,row?.pricing?.final_amount )} </div> },

    { label: "السائق", accessor: "courier.name" },
    {
      label: "الحالة",
      render: (row) => <StatusBadge status={row?.status?.value} />,
    },
    { label: "التاريخ   ", accessor: "created_at" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={`${process.env.PUBLIC_URL}/orders/${row.id}`}
          viewPermission={"view_order"}
        />
      ),
    },
  ];

  return (
    <div>
        <DataTable  isLoading={isLoading} columns={ordersColumns}  data={orders} totalItems={totalItems} itemsPerPage={lastPage} currentPage={current_page} setCurrentPage={setCurrentPage}/>
    </div>
  )
}

export default OrdersInfo